<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { getToken, removeToken } from '@/utils/auth'
import { getCurrentUser } from '@/api/auth'
// ✨ 新增：引入状态上报（心跳）接口
import { reportOnlineStatus } from '@/api/student/onlineStatus'

export default {
  name: 'App',
  data() {
    return {
      heartbeatTimer: null // ✨ 新增：用于存储心跳定时器
    }
  },
  async created() {
    // 页面初始化时检查并应用暗黑模式
    if (this.$store.state.isDarkMode) {
      document.documentElement.classList.add('dark-mode')
    }

    const token = getToken()
    if (!token) {
      return
    }
    try {
      const res = await getCurrentUser()
      // 如果触发了 401，request.js 会处理
      if (res && res._handled401) {
        return
      }
      if (res.code === 200) {
        this.$store.commit('SET_USER_INFO', res.data)

        // ✨ 新增核心逻辑：如果是学员登录，立刻启动全局心跳机制
        if (res.data.role === 'STUDENT') {
          this.startHeartbeat()
        }
      } else {
        removeToken()
        this.$store.commit('CLEAR_USER_INFO')
      }
    } catch (e) {
      removeToken()
      this.$store.commit('CLEAR_USER_INFO')
    }
  },
  // ✨ 新增：组件销毁时清理定时器，防止内存泄漏
  beforeDestroy() {
    this.stopHeartbeat()
  },
  methods: {
    // ✨ 新增：启动心跳的方法
    startHeartbeat() {
      this.stopHeartbeat() // 确保不会启动多个定时器

      // 每 60 秒发送一次心跳（因为后端是 2 分钟过期，60秒续命一次非常安全且不浪费带宽）
      this.heartbeatTimer = setInterval(async () => {
        const token = getToken()
        // 如果 token 丢失（比如用户点击了退出登录），则自动停止心跳
        if (!token) {
          this.stopHeartbeat()
          return
        }

        try {
          // 发送心跳。这里默认发 'IDLE'(空闲)，
          // 各个具体的业务页面(如考试页/练习页)会在自己的组件里发送 'EXAM' 或 'PRACTICE' 进行覆盖
          await reportOnlineStatus('IDLE')
        } catch (e) {
          console.log('心跳上报异常，可能网络波动', e)
        }
      }, 60000) // 60000 毫秒 = 60 秒
    },

    // ✨ 新增：停止心跳的方法
    stopHeartbeat() {
      if (this.heartbeatTimer) {
        clearInterval(this.heartbeatTimer)
        this.heartbeatTimer = null
      }
    }
  }
}
</script>

<style>
/* ================= 全局暗黑模式滤镜魔法 ================= */
/* 核心：颜色反转 100%，色相旋转 180 度 */
html.dark-mode {
  filter: invert(1) hue-rotate(180deg);
  /* 修复白底问题：这里必须填亮色！亮灰 #f5f7fa 反转后会变成高级深灰色，完美区分纯黑的卡片 */
  background: #f5f7fa;
  /* 确保 body 的透明底色也统一覆盖，防止部分浏览器透出白色 */
  min-height: 100vh;
  transition: filter 0.3s ease;
}

html.dark-mode body {
  background: #f5f7fa;
}

/* 抵消图片的滤镜，让图片、验证码、视频等恢复正常的颜色 */
html.dark-mode img,
html.dark-mode .captcha-img,
html.dark-mode .el-image__inner {
  filter: invert(1) hue-rotate(180deg);
}

/* ================= 页面横向展示魔法 ================= */
html.landscape-mode body {
  transform: rotate(90deg);
  transform-origin: center center;
  width: 100vh !important;
  height: 100vw !important;
  position: fixed !important;
  top: 50% !important;
  left: 50% !important;
  margin-top: -50vw !important;
  margin-left: -50vh !important;
  overflow: auto !important;
  background: #f5f7fa;
}
</style>